import { MKT_STATUS_TYPE } from 'helpers/marketplaceStatus';
import { getLiveOvertimeBubble } from '../bubbles';

const getLiveOfferStatus = ({ currentUserTopOfferer, vehicle }) => {
	const { my_offer_amount, best_offer_amount } = vehicle;
	const currentUserHasOffered = !!my_offer_amount;
	const hasOffer = !!best_offer_amount;

	if (hasOffer) {
		return getLiveOvertimeBubble(currentUserTopOfferer, currentUserHasOffered, vehicle);
	} else {
		return { unifiedStatusType: MKT_STATUS_TYPE.awaitingBids };
	}
};

export default getLiveOfferStatus;
